module.exports = {"420626100":"城关镇","420626101":"黄堡镇","420626102":"后坪镇","420626103":"龙坪镇","420626104":"店垭镇","420626105":"马良镇","420626106":"歇马镇","420626107":"马桥镇","420626108":"寺坪镇","420626109":"过渡湾镇","420626200":"两峪乡","420626400":"湖北保康经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420626.json
// module id = 1594
// module chunks = 0